
export const fieldTypes = {
    Text: 0,
    YesNo: 1,
    YesNoNA: 2
};
